import { VStack, Divider, Body, Box } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { ILink } from '../../interfaces/ILink';

interface Props {
  currentSection: string;
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const ANCHORS_LINKS: ILink[] = [
  {
    label: 'Our Values',
    to: '#careers-our-values',
  },
  {
    label: 'Our People',
    to: '#careers-our-people',
  },
  {
    label: 'Open Roles',
    to: '#open-roles',
  },
  {
    label: 'FAQ',
    to: '#faq',
  },
];

const FloatingLinks: React.FC<Props> = ({
  currentSection,
  setCurrentSection,
}) => {
  const [padding, setPadding] = useState<number>(0);

  useEffect(() => {
    setPadding(Math.max(0, (window.innerWidth - 1300) / 2));
    const callback = () =>
      setPadding(Math.max(0, (window.innerWidth - 1300) / 2));
    window.addEventListener('resize', callback);

    return () => window.removeEventListener('resize', callback);
  }, []);

  return (
    <Box
      w="100px"
      mt={97}
      mb={97}
      zIndex={1}
      ml={500}
      left={`${padding}px`}
      d={{ base: 'none', desktop: 'block' }}
      position="sticky"
      top="33vh"
    >
      <Box
        flexDir="column"
        w="100px"
        justifyContent="center"
        zIndex={1}
        transform="auto"
      >
        <Divider
          borderColor="neutral.300"
          my={100}
          borderWidth="1px"
          borderTopWidth={0}
        />
        <VStack
          height="188px"
          divider={<Divider borderColor="neutral.300" />}
          alignItems="flex-start"
        >
          {ANCHORS_LINKS.map(link => (
            <AnchorLink
              to={`/careers${link.to}`}
              stripHash
              key={link.to}
              onAnchorLinkClick={() => setCurrentSection(link.label)}
            >
              <Body
                ml={200}
                lineHeight={200}
                cursor="pointer"
                color={
                  currentSection === link.label ? 'primary.500' : 'neutral.900'
                }
                my={200}
                textAlign="left"
                size={500}
                key={link.label}
                isSemiBold
              >
                {link.label}
              </Body>
            </AnchorLink>
          ))}
        </VStack>
        <Divider
          borderColor="neutral.300"
          mt={400}
          borderWidth="1px"
          borderTopWidth={0}
        />
      </Box>
    </Box>
  );
};

export default FloatingLinks;
